import PropTypes from 'prop-types';
import './App.css';
import { connect } from "react-redux"
import { Routes, Route } from 'react-router-dom';
import Header from "./components/header";
import Footer from "./components/footer";
import Layout from './components/Layout'
import DepositPage from './pages/DepositPage';
import AllRoutes from "./routes/allRoutes"


const App = props => {

  // function getLayout() {
  //  //  let layoutCls = VerticalLayout
  //   return null;
  // }

 // const Layout = getLayout()
return (
  <div style={{ overflow:"hidden" }}>
    <Routes>
      <Route path="/deposit" element={<DepositPage />} />
      <Route path="/*" element={<Layout><AllRoutes /></Layout>} />
    </Routes>
  </div>
  );
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
